import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// 🔔 Toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Layouts
import UserLayout from "./layouts/UserLayout";
import AdminLayout from "./layouts/AdminLayout";
import AdminRoute from "./routes/AdminRoute";
import UserRoute from "./routes/UserRoute";

// USER PAGES
import HomePages from "./components/users/HomePages";
import Login from "./components/users/Login";
import SeeJobs from "./components/users/SeeJobs";
import ApplyLeave from "./components/users/ApplyLeave";
import JobTable from "./components/users/JobTable";
import LeaveChart from "./components/users/LeaveChart";
import LeaveHistory from "./components/users/LeaveHistory";
import HolidayForm from "./components/users/HolidayForm";
import EmployeeLeaveBalance from "./components/users/EmployeeLeaveBalance";
import JobCandidates from "./components/users/JobCandidates";
import CandidateReport from "./components/users/CandidateReport";
import ResetPassword from "./components/users/ResetUserPassword";
import CandidateSummary from "./components/users/CandidateSummary";
import BajajSummarySheet from "./components/users/BajajSummarySheet";
import MyPayslip from "./components/users/MyPayslip";
//  Dashboard (Header + Sidebar included inside)
import DashBoard from "./components/users/Dashboard";

// ADMIN PAGES
import AdminLogin from "./components/admin/Auth/AdminLogin";
import Core from "./components/admin/pages/Core";
import AllUser from "./components/admin/pages/AllUser";
import AllJoining from "./components/admin/pages/AllJoining";
import AllInterviews from "./components/admin/pages/ALlInterviews";
import BusinessReport from "./components/admin/pages/BusinessReport";
import ClosureReport from "./components/admin/pages/ClosureReport";
import SubmissionReport from "./components/admin/pages/SubmissionReport";
import Holidays from "./components/admin/pages/Holidays";
import Events from "./components/admin/pages/Events";
import Department from "./components/admin/pages/Department";
import Designation from "./components/admin/pages/Designation";
import TaskAllocation from "./components/admin/pages/TaskAllocation";
import Branch from "./components/admin/pages/Branch";
import Vendor from "./components/admin/pages/Vendor";
import RecruiterReport from "./components/admin/pages/RecruiterReport";
import HolidayChart from "./components/admin/pages/HolidayChart";
import AllUserAttendance from "./components/admin/pages/AllUserAttendance";
import AdminCandidateReport from "./components/admin/pages/AdminCandidateReport";
import PositionMatrix from "./components/admin/pages/PositionMatrix";
import Matrix from "./components/admin/pages/Matrix";
import AdminAttendance from "./components/admin/pages/AdminAttendance";
import DailyClosingReport from "./components/admin/pages/DailyClosingReport";
import TaskAssign from "./components/admin/pages/TaskAssign";
import EmpLeaveBalance from "./components/admin/pages/EmpLeaveBalance";


// Billing Pages
import InvoiceForm from "./components/billing/pages/InvoiceForm";
import CompanyList from "./components/billing/pages/CompanyList";
import InvoiceTable from "./components/billing/pages/InvoiceTable";
import InvoicePayment from "./components/billing/pages/InvoicePayment";
import ViewInvoice from "./components/billing/pages/ViewInvoice";
import InvoiceReport from "./components/billing/pages/InvoiceReport";
import PaymentReport from "./components/billing/pages/PaymentReport";
import TodayJobsReport from "./components/admin/pages/TodayJobsReport";
import TodaysCandidateReport from "./components/admin/pages/DailyCandidate";
import HierarchyManagement from "./components/admin/pages/HierarchyManagement";
import AdminSetting from "./components/admin/pages/Permissions";
import CareerJobPage from "./components/users/CareerJobPage";

function App() {
  return (
    <Router>
      <>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          newestOnTop
          pauseOnHover
          closeOnClick
          draggable
          theme="colored"
        />

        <Routes>
          {/*  USER PUBLIC ROUTES */}
          <Route element={<UserLayout />}>
            <Route path="/" element={<HomePages />} />
            <Route path="/login" element={<Login />} />
            <Route path="/seejob" element={<SeeJobs />} />
            <Route path="/career/job/:reqId" element={<CareerJobPage />}
            />

            {/* User Pages */}
            {/* <Route path="/apply-leave" element={<ApplyLeave />} /> */}
            <Route path="/jobtable" element={<UserRoute><JobTable /></UserRoute>} />
            <Route path="/leavechart" element={<UserRoute><LeaveChart /></UserRoute>} />
            <Route path="/leave-history" element={<UserRoute><LeaveHistory /></UserRoute>} />
            <Route path="/holidayform" element={<UserRoute><HolidayForm /></UserRoute>} />
            <Route path="/my-leave-balance" element={<UserRoute><EmployeeLeaveBalance /></UserRoute>} />
            <Route path="/jobcandidates/:reqId" element={<UserRoute><JobCandidates /></UserRoute>} />
            <Route path="/candidate_report" element={<UserRoute><CandidateReport /></UserRoute>} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Attendance */}
            <Route path="/admin-attendance" element={<UserRoute><AllUserAttendance /></UserRoute>} />
          </Route>

          <Route path="/candidate-summary/:id" element={<CandidateSummary />} />
          <Route path="/bajaj-summary-sheet/:id" element={<BajajSummarySheet />} />

          {/*  DASHBOARD ROUTES (Header + Sidebar always shown) */}
          <Route path="/dashboard/*" element={<UserRoute><DashBoard /></UserRoute>} />

          {/*  ADMIN ROUTES */}
          <Route path="/adminlogin" element={<AdminLogin />} />

          <Route
            path="/adminhome"
            element={
              <AdminRoute>
                <AdminLayout>
                  <Core />
                </AdminLayout>
              </AdminRoute>
            }
          />

          <Route
            path="/adminattendance"
            element={
              <AdminLayout>
                <AdminAttendance />
              </AdminLayout>
            }
          />

          <Route
            path="/admincandidatereport"
            element={
              <AdminLayout>
                <AdminCandidateReport />
              </AdminLayout>
            }
          />

          <Route
            path="/closingreport"
            element={
              <AdminLayout>
                <DailyClosingReport />
              </AdminLayout>
            }
          />

          <Route path="/employee" element={<AdminLayout><AllUser /></AdminLayout>} />
          <Route path="/designation" element={<AdminLayout><Designation /></AdminLayout>} />
          <Route path="/department" element={<AdminLayout><Department /></AdminLayout>} />
          <Route path="/branch" element={<AdminLayout><Branch /></AdminLayout>} />
          <Route path="/vendor" element={<AdminLayout><Vendor /></AdminLayout>} />
          <Route path="/holidays" element={<AdminLayout><Holidays /></AdminLayout>} />
          <Route path="/holidaychart" element={<AdminLayout><HolidayChart /></AdminLayout>} />
          <Route path="/events" element={<AdminLayout><Events /></AdminLayout>} />
          <Route path="/recruiter-report" element={<AdminLayout><RecruiterReport /></AdminLayout>} />
          <Route path="/bd-report" element={<AdminLayout><BusinessReport /></AdminLayout>} />
          <Route path="/submission-report" element={<AdminLayout><SubmissionReport /></AdminLayout>} />
          <Route path="/interview-report" element={<AdminLayout><AllInterviews /></AdminLayout>} />
          <Route path="/joining-report" element={<AdminLayout><AllJoining /></AdminLayout>} />
          <Route path="/closure-report" element={<AdminLayout><ClosureReport /></AdminLayout>} />
          <Route path="/matrix" element={<AdminLayout><Matrix /></AdminLayout>} />
          <Route path="/taskallocation" element={<AdminLayout><TaskAllocation /></AdminLayout>} />
          <Route path="/emp-leave-bal" element={<AdminLayout><EmpLeaveBalance /></AdminLayout>} />
          <Route path="/admin-task" element={<AdminLayout><TaskAssign /></AdminLayout>} />
          <Route path="/jobs-report" element={<AdminLayout><TodayJobsReport /></AdminLayout>} />
          <Route path="/candidate-report" element={<AdminLayout><TodaysCandidateReport /></AdminLayout>} />
          <Route path="/teams" element={<AdminLayout><HierarchyManagement /></AdminLayout>} />
          <Route path="/admin-setting" element={<AdminLayout><AdminSetting /></AdminLayout>} />
          <Route
            path="payslip"
            element={
              <UserRoute>
                <MyPayslip />
              </UserRoute>
            }
          />



          {/* BILLING ROUTES */}
          <Route
            path="/new-invoice"
            element={
              <AdminLayout>
                <InvoiceForm />
              </AdminLayout>
            }
          />

          <Route path="/company_list" element={<AdminLayout><CompanyList /></AdminLayout>} />

          <Route path="/invoive_master" element={<AdminLayout><InvoiceTable /></AdminLayout>} />

          <Route
            path="/invoice-payment/:id"
            element={
              <AdminLayout>
                <InvoicePayment />
              </AdminLayout>
            }
          />

          <Route path="/view-invoice/:id" element={<ViewInvoice />} />

          <Route
            path="/edit-invoice/:invoiceId"
            element={
              <AdminLayout>
                <InvoiceForm />
              </AdminLayout>
            }
          />

          <Route path="/invoice-report" element={<AdminLayout><InvoiceReport /></AdminLayout>} />
          <Route path="/payment-report" element={<AdminLayout><PaymentReport /></AdminLayout>} />
        </Routes>
      </>
    </Router>
  );
}

export default App;